/**
 * @flow
 * @relayHash 60cf9a0fd6120e19a7cac0f983378223
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type CreateWidgetMutationVariables = {|
  input: {
    reportId: string;
    name?: ?string;
    type?: ?string;
    config?: ?{
      question?: ?string;
      filterComments?: ?boolean;
      sliceByQuestion?: ?string;
      aggregateQuestions?: ?$ReadOnlyArray<?string>;
      subtitle?: ?string;
      ignoreDateFilter?: ?boolean;
      showLastXMonths?: ?number;
      hideHeader?: ?boolean;
      hideCommentTime?: ?boolean;
      staticYAxisScale?: ?boolean;
      commentExtraColumns?: ?$ReadOnlyArray<?{
        questionId?: ?string;
        title?: ?string;
      }>;
    };
    clientMutationId?: ?string;
  };
|};

export type CreateWidgetMutationResponse = {|
  +createWidget: ?{|
    +widget: ?{|
      +id: string;
      +mongoId: ?string;
      +name: ?string;
      +type: ?string;
      +config: ?{|
        +filterComments: ?boolean;
        +sliceByQuestion: ?string;
        +aggregateQuestions: ?$ReadOnlyArray<?string>;
        +subtitle: ?string;
        +ignoreDateFilter: ?boolean;
        +showLastXMonths: ?number;
        +hideHeader: ?boolean;
        +hideCommentTime: ?boolean;
        +staticYAxisScale: ?boolean;
        +commentExtraColumns: ?$ReadOnlyArray<?{|
          +title: ?string;
          +questionId: ?string;
        |}>;
        +question: ?{|
          +id: string;
          +firstAnswerTime: ?string;
        |};
      |};
    |};
  |};
|};
*/


/*
mutation CreateWidgetMutation(
  $input: CreateWidgetInput!
) {
  createWidget(input: $input) {
    widget {
      id
      mongoId
      name
      type
      config {
        filterComments
        sliceByQuestion
        aggregateQuestions
        subtitle
        ignoreDateFilter
        showLastXMonths
        hideHeader
        hideCommentTime
        staticYAxisScale
        commentExtraColumns {
          title
          questionId
        }
        question {
          id
          firstAnswerTime
        }
      }
    }
  }
}
*/

const batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "input",
        "type": "CreateWidgetInput!",
        "defaultValue": null
      }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateWidgetMutation",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "CreateWidgetInput!"
          }
        ],
        "concreteType": "CreateWidgetPayload",
        "name": "createWidget",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Widget",
            "name": "widget",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "id",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "mongoId",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "name",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "type",
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "WidgetConfig",
                "name": "config",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "filterComments",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "sliceByQuestion",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "aggregateQuestions",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "subtitle",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "ignoreDateFilter",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "showLastXMonths",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "hideHeader",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "hideCommentTime",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "staticYAxisScale",
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "commentExtraColumn",
                    "name": "commentExtraColumns",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "title",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "questionId",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "Question",
                    "name": "question",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "id",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "firstAnswerTime",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "CreateWidgetMutation",
  "query": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "input",
        "type": "CreateWidgetInput!",
        "defaultValue": null
      }
    ],
    "kind": "Root",
    "name": "CreateWidgetMutation",
    "operation": "mutation",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "CreateWidgetInput!"
          }
        ],
        "concreteType": "CreateWidgetPayload",
        "name": "createWidget",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Widget",
            "name": "widget",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "id",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "mongoId",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "name",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "type",
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "WidgetConfig",
                "name": "config",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "filterComments",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "sliceByQuestion",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "aggregateQuestions",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "subtitle",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "ignoreDateFilter",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "showLastXMonths",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "hideHeader",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "hideCommentTime",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "staticYAxisScale",
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "commentExtraColumn",
                    "name": "commentExtraColumns",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "title",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "questionId",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "Question",
                    "name": "question",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "id",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "firstAnswerTime",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "text": "mutation CreateWidgetMutation(\n  $input: CreateWidgetInput!\n) {\n  createWidget(input: $input) {\n    widget {\n      id\n      mongoId\n      name\n      type\n      config {\n        filterComments\n        sliceByQuestion\n        aggregateQuestions\n        subtitle\n        ignoreDateFilter\n        showLastXMonths\n        hideHeader\n        hideCommentTime\n        staticYAxisScale\n        commentExtraColumns {\n          title\n          questionId\n        }\n        question {\n          id\n          firstAnswerTime\n        }\n      }\n    }\n  }\n}\n"
};

module.exports = batch;



// WEBPACK FOOTER //
// ./src/mutations/__generated__/CreateWidgetMutation.graphql.js